import React from 'react';

import { LoadableBackground } from '@confluence/loadable';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

const ImpersonationFlagV2Loader = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ImpersonationFlag" */ './ImpersonationFlag.tsx'))
			.ImpersonationFlag,
});

const LazyImpersonationFlagComponent = () => <ImpersonationFlagV2Loader />;

export const LazyImpersonationFlag = withTransparentErrorBoundary({
	attribution: Attribution.PERMISSIONS_EXPERIENCE,
})(LazyImpersonationFlagComponent);
